module.exports = (Promise.resolve(__parcel__require__("./" + "RistrettoPlaying.a3a31157.9b767c49.js"))).then(() => parcelRequire('g6408'));